import Image from "next/image";
import { chakra } from "@chakra-ui/react"

export const ChakraImage = chakra(Image, {
    shouldForwardProp: (prop) =>
    ["width", "height", "src", "alt", "layout"].includes(prop),
})
